import { StyleSheet } from 'react-native';

import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  root: {
  },
  infoContainer: {
    width: 300,
    marginTop: 56,
    marginBottom: 26,
    minHeight: 12,
  },
  infoContainerText: {
    textAlign: 'center',
  },
  errorContainer: {
    backgroundColor: PALETTE.errorColor,
    marginTop: 56,
    marginBottom: 26,
    paddingVertical: 5,
    paddingHorizontal: 10,
    minHeight: 12,
  },
  leanMoreIcon: {
    width: 15,
    height: 15,
  }
});
